export const version = "1.7.22";
export const channel = "release";
export const gitcommit = "unknown";
